

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { setResultModalData, showModal } from "../modal/modalSlice";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {

    activeInput: null,

    //! get ile veriler alındığında verileri değişmeyecek şekilde buna aktarıyoruz ekstra olarak (bu verileri güncelleme işleminde verilerin hangilerinin güncellendiğini bununla kıyaslıyoruz.)
    constantSeferMaliyetData: null,

    seferMaliyetData: [],
    
    kopruUcretList: [],
    feribotUcretList: [],

    kopruListforNakliyehesaplama: [],
    feribotListForNakliyeHesaplama: [],

    isLoading:  false,
    isLoadingGetDefaultMaliyetHesabi: false,
    isloadingUpdateDefaultMaliyetHesabi: false,
    isError: false,

    costCalculateDataList: [],
    isLoadingGetDefaultMaliyetHesabiCostCalculate: false


}


export const getDefaultMaliyetHesabi = createAsyncThunk("calc/getDefaultMaliyetHesabi", async(_,thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/MaliyetHesabi/GetDefaultMaliyetHesabi`)
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const updateDefaultMaliyetHesabi = createAsyncThunk("calc/updateDefaultMaliyetHesabi", async(updatedData,thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`/MaliyetHesabi/updateDefaultMaliyetHesabi`, updatedData)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Sefer maliyet bilgileri başarıya güncellendi.",resultType: "success", btnText1: "Tabloyu Görüntüle"}))
            thunkApi.dispatch(getDefaultMaliyetHesabi())
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Tabloyu Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getDefaultMaliyetHesabiCostCalculate = createAsyncThunk("calc/getDefaultMaliyetHesabiCostCalculate", async(kmData,thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/MaliyetHesabi/GetDefaultShipmentCostCalculate?km=${kmData}`)
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getKopruGemiUcret = createAsyncThunk("calc/getKopruGemiUcret", async(_,thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/MaliyetHesabi/GetKopruVeGemiUcretleri`)
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getFeribotUcret = createAsyncThunk("calc/getFeribotUcret", async(_,thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/MaliyetHesabi/GetFeribotUcretleri`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getCurrentYakitFiyat = createAsyncThunk("calc/getCurrentYakitFiyat", async(_,thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/AkaryakitFiyatlari/GetSavedFuelPrices`)

        const yakitDataa = data.data.motorinPrice.toString().replace(".", ",");
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getKdv = createAsyncThunk("calc/getKdv", async(_,thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/MaliyetHesabi/GetKdvOrani`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})
 
const calcSlice = createSlice({
    name: "calc",
    initialState,
    reducers: {
        //! bu sırf inputların arasında number input un arasında . gözükmesi için 
        getActiveInput: (state,action) => {
            state.activeInput = action.payload
        },

        //! bu sefer maliyet bilgileri sayfasındaki tabloda düzenleme yapıldığında çalışıyor 
        updateSeferMaliyetData: (state,action) => {
        const {value, id, key} = action.payload

        state.seferMaliyetData = state.seferMaliyetData.map((item) => {
            if(item.id === id){
                return {
                    ...item, [key]: value
                }
            }
            else{
                return item
            }
        })
        },

        //! bu input a girilen veya nakliye fiyat hesaplamadaki km data sından gelen 
        updateKmData: (state, action) => {
            state.kmData = action.payload
        },

        //! bu nakliye fiyat hesaplama sayfasındaki girilen köprü itemlerini ekleyen
        addKopruItemforNakliyeHesaplama:(state, action) => {
            state.kopruListforNakliyehesaplama = [action.payload, ...state.kopruListforNakliyehesaplama]
        },

        //! bu nakliye fiyat hesaplama sayfasındaki girilen köprü itemlerini silen
        deleteKopruItemforNakliyeHesaplama: (state, action) => {
            state.kopruListforNakliyehesaplama = state.kopruListforNakliyehesaplama.filter((item) => {
                return item.id !== action.payload.id
            })
        },

        //! bu nakliye fiyat hesaplama sayfasından çıkarken state resetleyen
        resetKopruItemforNakliyeHesaplama: (state) => {
            state.kopruListforNakliyehesaplama = []
        },

        //! bu nakliye fiyat hesaplama sayfasındaki girilen feribot itemlerini ekleyen
        addFeribotItemforNakliyeHesaplama: (state,action) => {
            state.feribotListForNakliyeHesaplama = [action.payload, ...state.feribotListForNakliyeHesaplama]
        },

        //! bu nakliye fiyat hesaplama sayfasındaki girilen feribot itemlerini silen
        deleteFeribotItemforNakliyeHesaplama: (state,action) => {
            state.feribotListForNakliyeHesaplama = state.feribotListForNakliyeHesaplama.filter((item) => {
                return item.id !== action.payload.id
            })
        },

        //! bu nakliye fiyat hesaplama sayfasından çıkarken state resetleyen
        resetFeribotItemforNakliyeHesaplama: (state) => {
            state.feribotListForNakliyeHesaplama = []
        },


        
        clearCalcState: (state) => {
            return initialState
        }
    },
    extraReducers:(builder)=> {
        builder

        // get default maliyet hesabi
        .addCase(getDefaultMaliyetHesabi.pending, (state)=> {
            state.isLoadingGetDefaultMaliyetHesabi = true
        })

        .addCase(getDefaultMaliyetHesabi.fulfilled, (state, action)=> {
            state.isLoadingGetDefaultMaliyetHesabi = false
            state.seferMaliyetData = action.payload.data.$values
            state.constantSeferMaliyetData = action.payload.data.$values
        })

        .addCase(getDefaultMaliyetHesabi.rejected, (state, action)=> {
            state.isLoadingGetDefaultMaliyetHesabi = false
            state.isError = true
        })

        // update default maliyet hesabi
        .addCase(updateDefaultMaliyetHesabi.pending, (state)=> {
            state.isloadingUpdateDefaultMaliyetHesabi = true
        })

        .addCase(updateDefaultMaliyetHesabi.fulfilled, (state, action)=> {
            state.isloadingUpdateDefaultMaliyetHesabi = false
        })

        .addCase(updateDefaultMaliyetHesabi.rejected, (state, action)=> {
            state.isloadingUpdateDefaultMaliyetHesabi = false
            state.isError = true
        })




        //! getDefaultMaliyetHesabiCostCalculate
        .addCase(getDefaultMaliyetHesabiCostCalculate.pending, (state)=> {
            state.isLoadingGetDefaultMaliyetHesabiCostCalculate = true
        })

        .addCase(getDefaultMaliyetHesabiCostCalculate.fulfilled, (state, action)=> {
            state.isLoadingGetDefaultMaliyetHesabiCostCalculate = false
            state.costCalculateDataList = action.payload.data.$values
        })

        .addCase(getDefaultMaliyetHesabiCostCalculate.rejected, (state, action)=> {
            state.isLoadingGetDefaultMaliyetHesabiCostCalculate = false
        })


        // getCurrentYakitFiyat
        .addCase(getCurrentYakitFiyat.pending, (state)=> {
            state.isLoading = true
        })

        .addCase(getCurrentYakitFiyat.fulfilled, (state, action)=> {
            state.isLoading = false
            state.yakitData = action.payload.data.motorinPrice
        })

        .addCase(getCurrentYakitFiyat.rejected, (state, action)=> {
            state.isLoading = false
            state.isError = true
        })

        // getKdv
        .addCase(getKdv.pending, (state)=> {
            state.isLoading = true
        })

        .addCase(getKdv.fulfilled, (state, action)=> {
            state.isLoading = false
            state.kdvData = action.payload.data.kdvRate
        })

        .addCase(getKdv.rejected, (state, action)=> {
            state.isLoading = false
            state.isError = true
        })

        // getKopruGemiUcret
        .addCase(getKopruGemiUcret.pending, (state)=> {
            state.isLoading = true
        })

        .addCase(getKopruGemiUcret.fulfilled, (state, action)=> {
            state.isLoading = false
            state.kopruUcretList = action.payload.data.$values
        })

        .addCase(getKopruGemiUcret.rejected, (state, action)=> {
            state.isLoading = false
            state.isError = true
        })

        // getFeribotUcret
        .addCase(getFeribotUcret.pending, (state)=> {
            state.isLoading = true
        })

        .addCase(getFeribotUcret.fulfilled, (state, action)=> {
            state.isLoading = false
            state.feribotUcretList = action.payload.data.$values
        })

        .addCase(getFeribotUcret.rejected, (state, action)=> {
            state.isLoading = false
            state.isError = true
        })
   
    }
})


export const {
    updateSeferMaliyetData,
    clearCalcState,
    getActiveInput,
    updateKmData,
    addKopruItemforNakliyeHesaplama,
    deleteKopruItemforNakliyeHesaplama,
    addFeribotItemforNakliyeHesaplama,
    deleteFeribotItemforNakliyeHesaplama,
    resetFeribotItemforNakliyeHesaplama,
    resetKopruItemforNakliyeHesaplama
} = calcSlice.actions
export default calcSlice.reducer
